import { Badge } from '@/components/ui/badge';
import type { TaskRefresh } from '@rock/types';
import { assertUnreachable } from '@rock/util';
import type { FC } from 'react';

export const RefreshStatusBadge: FC<{ status: TaskRefresh['status'] }> = ({ status }) => {
    switch (status) {
        case 'requested':
            return <Badge variant="outline">requested</Badge>;
        case 'in-progress':
            return <Badge className="bg-blue-600">in-progress</Badge>;
        case 'complete':
            return <Badge className="bg-green-600">complete</Badge>;
        case 'error':
            return <Badge variant="destructive">error</Badge>;
        case 'needs-brand':
            return <Badge className="bg-amber-500">needs brand</Badge>;
        default:
            assertUnreachable(status);
    }
};
